import { connect } from 'react-redux'
import {
  compose, lifecycle, withHandlers, withState,
} from 'recompose'
import { bindActionCreators } from 'redux'
import { fetchNewsByCategory, fetchCategoryDetail } from 'actions/PublicNews'
import Category from 'components/publicPages/infoBerita/category'

const mapStateToProps = () => ({})

const mapDispatchToProps = dispatch => ({
  fetchNewsByCategory: bindActionCreators(fetchNewsByCategory, dispatch),
  fetchCategoryDetail: bindActionCreators(fetchCategoryDetail, dispatch)
})

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withState('pengumuman', 'setPengumuman', {}),
  withState('category', 'setCategory', {}),
  withHandlers({
    getListPengumuman: props => async (params) => {
      const { setPengumuman } = props
      try {
        const res = await props.fetchNewsByCategory(params)
        setPengumuman({
          list: res.data,
          meta: res.meta
        })
      } catch (err) {
        console.log(err)
      }
    }
  }),
  withHandlers({
    getDetail: props => async (params) => {
      const { setCategory } = props
      try {
        const res = await props.fetchCategoryDetail(params)
        setCategory(res)
      } catch (err) {
        console.log(err)
      }
    }
  }),
  lifecycle({
    componentDidMount() {
      this.props.getListPengumuman(`?category=${this.props.match.params.id}&limit=12&status=active`);
      this.props.getDetail(this.props.match.params.id)
    },
  }),
)(Category)
